import React from 'react';
import { CrudService } from './CrudService';
import { apiClient } from './ApiClient';

const crudService = CrudService('roles');
export const getRoles = async (inputData: any) => { return await crudService.getItems(inputData); }
export const getRoleById = async (inputData: any) => { return await crudService.getItemById(inputData); }
export const addRole = async (inputData: any) => { return await crudService.addItem(inputData); }
export const updateRole = async (inputData: any) => { return await crudService.updateItem(inputData); }
export const deleteRole = async (inputData: any) => { return await crudService.deleteItem(inputData); }

export const getAssignedControls = async (token: any) => {
    let apiOptions: any = {
        url: `Roles/GetAssignedControls`,
        method: 'get'
    }
    let result: any = await apiClient.doAction(apiOptions, token);
    return result;
}
